import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatTime } from '../../../../utils/messageRenderUtils';
import MessageInfoSection from '../MessageInfoSection/MessageInfoSection';
import { getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const { Text } = Typography;

const MessageReactions = ({ reactions, isDarkMode }) => {
    const { t } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!reactions?.length) return null;

    return (
        <MessageInfoSection title={t('reactions')}>
            <Space direction="vertical">
                {reactions.map((reaction, index) => (
                    <Space key={index}>
                        <Tag>{reaction.emoji}</Tag>
                        <Text style={{ color: themeColors.text }}>{reaction.sender_type}</Text>
                        <Text type="secondary" style={{ color: themeColors.secondaryText }}>{formatTime(reaction.sent_at)}</Text>
                    </Space>
                ))}
            </Space>
        </MessageInfoSection>
    );
};

export default MessageReactions;
